import React from "react";
import { Routes, Route } from "react-router-dom";
import UtahVerticals from "./pages/UtahVerticals";
import UtahAtAGlance from "./pages/UtahAtAGlance";
import UtahData from "./pages/UtahData";
import UtahChargingStation from "./pages/UtahChargingStation";
import Manufacturing from "./pages/Manufacturing";
import Aerospace from "./pages/Aerospace";
import ScrollToTop from "./pages/ScrollToTop";
import PopulationDemography from "./pages/PopulationDemography";
import Information from "./pages/Information";
import FoodIndustry from "./pages/FoodIndustry";
import UtahJobs from "./pages/UtahJobs";
import UtahHousing from "./pages/UtahHousing";
import UnemploymentRate from "./pages/UnemploymentRate";
import DataSet from "./pages/DataSet";
import Airports from "./pages/Airports";
import UtahGovernor from "./pages/UtahGovernor";
import UtahCounties from "./pages/UtahCounties";
import UtahState from "./pages/UtahState";
import GeothermalMap from "./pages/GeoThermal";
import UtahPowergrid from "./pages/UtahPowergrid";
import HillAFBEconomicImpact from "./pages/HillAFBEconomicImpact";
import Gallery from "./pages/Gallery";
import MLM from "./pages/MLM";
import Hospital from "./pages/Hospital";
import NonProfits from "./pages/NonProfits";
import AirQuality from "./pages/AirQuality";
import Tax from "./pages/Tax";
import DashboardLayoutBasic from "./pages/Culture";
import CultReligious from "./pages/CultReligious";
import CultHistory from "./pages/CultHistory";
import CultFestival from "./pages/CultFestival";
import PlacesToVisit from "./pages/PlacesToVisit";
import PlacesNationalForest from "./pages/PlacesNationalForest";
import PlaceMonument from "./pages/PlaceMonument";
import PlacesWildlifeRefuges from "./pages/PlacesWildlifeRefuges";
import PlacesRecreation from "./pages/PlacesRecreation";
import Placeshistory from "./pages/Placeshistory";
import PlacesForestService from "./pages/PlacesForestService";
import PlacesLand from "./pages/PlacesLand";
import StateParks from "./pages/StateParks";
import Zipcode from "./pages/Zipcode";
import AgencyCards from "./pages/AgencyCardsNew";
import Sports from "./pages/SportsClub";
import Adventure from "./pages/Adventure";
import Airforce from "./pages/Airforce";
import Contactai from "./pages/AIContactForm";
import About from "./pages/About";
import UtahVotersCount from "./pages/UtahVotersCount";
import CopyRight from "./pages/copyright";
import BFMfaqs from "./pages/BFMfaqs";
import WIP from "./pages/WIP";
import Naics from "./pages/naics";
import NaicsRules from "./pages/naicsRules";
import NaicsRulesVariant from "./pages/naicsRulesVariant";
import KCG from "./pages/KCG";
import AskBetsyAI from "./pages/AskBetsyAI";
import EngineeringAndTechnology from "./pages/EngineeringAndTechnology";
import Finance from "./pages/Finance";
import NationalPark from "./pages/NationalPark";
import NationalPark1 from "./pages/NationalPark1";
import NationalPark2 from "./pages/NationalPark2";
import NationalPark3 from "./pages/NationalPark3";
import NationalPark4 from "./pages/NationalPark4";
import NationalPark5 from "./pages/NationalPark5";
import Login from "./pages/Login";
import UtahUniversities from "./pages/UtahUniversities";
import EducationResources from "./pages/EducationResources";
import UtahCities from "./pages/UtahCities";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UtahSchools from "./pages/UtahSchools";
import CharteredSchools from "./pages/CharteredSchools";
import SiteMapPage from "./pages/sitemap-view";
import { Helmet, HelmetProvider } from "react-helmet-async";
import SchoolDistrict from "./pages/SchoolDistrict";
import MinesPage from "./pages/MinesPage";
import ResearchCenters from "./pages/ResearchCenters";
import Library from "./pages/Library";
import LibraryNew from "./pages/LibraryNew";
import "./App.css";
// import UtahAtAGlanceDraft from "./pages/UtahAtAGlanceDraft";
import Honeycomb from "./pages/Honeycomb";
// import UtahAtAGlance from "./pages/UtahAtAGlance";
import SiteMap2 from "./pages/SiteMap2";
import FAQ from "./pages/FAQ";
import FounderNote from "./pages/FounderNote";
import UtahCounty from "./pages/UtahCounty";
import Sp from "./pages/Sp";
import LoginUtah from "./pages/LoginUtah";
import VisitorInfo from "./pages/Info";
import SupportForm from "./pages/SupportForm";
import LoginSubscription from "./pages/LoginSubscription";
import SupportForm1 from "./pages/SupportForm 1";
import Sponsors from "./pages/Sponsors";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Sponsors1 from "./pages/Sponsors 1";
import SupportForm2 from "./pages/SupportForm 2";
import EconomicImpact from "./pages/EconomicImpact";
import Torch404 from "./pages/Torch404";
import Urrad from "./pages/Urrad";
import TransportationAndWarehousing from "./pages/TransportationAndWarehousing";
import SmallBusinessUtahPage from "./pages/utahfaq";
import SmallBusinessFAQPage from "./pages/utahfaq";
import SmallBusinessFAQColorPage from "./pages/utahfaq";
import SmallBusinessFAQNeonPage from "./pages/utahfaq";
import SmallBusinessFAQLightPage from "./pages/utahfaq";
import Uradd1 from "./pages/Uradd1";
import UtahFunFacts from "./pages/FunFacts";
import Construction from "./pages/ConstructionVerticals";
import Mining from "./pages/Mining";
import UtahBudget from "./pages/UtahBudget";
import UnaLandingDashboard from "./pages/UNALandingPage";
// import KPIPage from "./pages/KPIPage";

import KCGSandbox from "./pages/KCGSandbox";
import KCGSandbox1 from "./pages/KCGSandbox1";
import KCGSandbox2 from "./pages/KCGSandbox2";
import KCGSandbox3 from "./pages/KCGSandbox3";
import KCGSandbox11 from "./pages/KCGSandbox1-1";

function App() {
  return (
    <>
      <ScrollToTop />
      <HelmetProvider>
        <Routes>
          {/* <Route path="/kpi" element={<KPIPage />} /> */}
          {/* <Route path="/utah-at-a-glance/utah-funfacts" element={<UtahFunFacts/>}/> */}
          {/* <Route path="/utah-at-a-glance/hillafb" element={<AtAGlanceHillAFB />} /> */}
          <Route
            path="/utah-at-a-glance/utah-funfacts"
            element={
              <>
                <Helmet>
                  <title>Utah Fun Facts | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Utah Fun Facts | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Discover fascinating fun facts about Utah — from its unique history and culture to its natural wonders and economy. Explore data-driven insights in a fun way."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-funfacts"
                  />
                  <meta
                    property="og:description"
                    content="Learn amazing fun facts about Utah's people, history, and landscapes with data-backed insights from UtahData.org."
                  />
                </Helmet>
                <UtahFunFacts />
              </>
            }
          />

          <Route path="/uradd1" element={<Uradd1 />} />
          {/* <Route path="/utah-at-a-glance/federal-agencies/sba-advocacy" element={<SmallBusinessFAQLightPage/>}/> */}
          <Route
            path="/utah-at-a-glance/federal-agencies/sba-advocacy"
            element={
              <>
                <Helmet>
                  <title>Small Business Advocacy | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Small Business Advocacy | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Explore insights, data, and resources from the Office of Advocacy of the U.S. Small Business Administration (SBA) at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/federal-agencies/sba-advocacy"
                  />
                  <meta
                    property="og:description"
                    content="Discover small business statistics and advocacy efforts from the SBA Office of Advocacy, empowering Utah entrepreneurs with data-driven insights."
                  />
                </Helmet>
                <SmallBusinessFAQLightPage />
              </>
            }
          />

          {/* <Route path="/utah-at-a-glance/autism-dd" element={<Urrad />} /> */}
          <Route
            path="/utah-at-a-glance/autism-dd"
            element={
              <>
                <Helmet>
                  <title>
                    Autism & Developmental Disabilities | UtahData.org
                  </title>
                  <meta
                    property="og:title"
                    content="Autism & Developmental Disabilities | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Explore Autism and Developmental Disabilities statistics powered by URADD. Gain insights into data that shape understanding and policy in Utah."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/autism-dd"
                  />
                  <meta
                    property="og:description"
                    content="Discover data and insights on Autism and Developmental Disabilities in Utah, powered by URADD."
                  />
                </Helmet>
                <Urrad />
              </>
            }
          />

          <Route path="/utah-at-a-glance/utah-autism-dd" element={<Urrad />} />
          <Route path="/eco" element={<EconomicImpact />} />
          <Route path="/login-utahdata" element={<LoginUtah />} />
          <Route path="/visitor-info" element={<VisitorInfo />} />
          {/* <Route path="/sponser-request" element={<SupportForm/>}/> */}
          <Route path="/support-sponsor-request1" element={<SupportForm1 />} />
          <Route path="/support-sponsor-request" element={<SupportForm2 />} />
          <Route path="/subscription-plans" element={<LoginSubscription />} />
          <Route
            path="/supporters-and-sponsors"
            element={
              <>
                <Helmet>
                  <title>Our Sponsors & Supporters | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Our Sponsors & Supporters | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="UtahData.org gratefully acknowledges the generous support of distinguished sponsors and supporters who help us achieve our mission of advancing data, innovation, and insights for Utah."
                  />
                  <link rel="canonical" href="https://utahdata.org/" />
                  <meta
                    property="og:description"
                    content="Discover the sponsors and visionary individuals whose generous support makes UtahData.org possible. Together, we are building a stronger, data-driven Utah."
                  />
                </Helmet>
                <Sponsors1 />
              </>
            }
          />
          {/* <Route path="/supporters-and-sponsors" element={<Sponsors1 />} /> */}
          <Route path="/profile" element={<Profile />} />
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>
                    Explore Utah by the Numbers | Utah Data | Statistics
                  </title>
                  <meta
                    property="og:title"
                    content="Explore Utah by the Numbers | Utah Data | Statistics"
                  />
                  <meta
                    name="description"
                    content="Explore Utah data, analytics & insights on the economy, demographics & more. View key trends & the Utah map to make informed decisions at UtahData.org."
                  />
                  <link rel="canonical" href="https://utahdata.org/" />
                  <meta
                    property="og:description"
                    content="Explore Utah data, analytics & insights on the economy, demographics & more. View key trends & the Utah map to make informed decisions at UtahData.org."
                  />
                </Helmet>
                <UtahData />
              </>
            }
          />

          <Route
            path="/verticals"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Data Verticals | Explore Key Sectors | Trends
                  </title>
                  <meta
                    property="og:title"
                    content="  Utah Data Verticals | Explore Key Sectors | Trends"
                  />
                  <meta
                    name="description"
                    content="Explore UtahData.org verticals for in-depth, interactive Utah data insights on Utah's economy, demographics, education, and more—empowering informed decisions."
                  />
                  <link rel="canonical" href="https://utahdata.org/verticals" />
                  <meta
                    property="og:description"
                    content="Explore UtahData.org verticals for in-depth, interactive Utah data insights on Utah's economy, demographics, education, and more—empowering informed decisions."
                  />
                </Helmet>
                <UtahVerticals />
              </>
            }
          />
          <Route
            path="/verticals/manufacturing"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Manufacturing Industry | Data, Growth | Analysis
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Manufacturing Industry | Data, Growth | Analysis"
                  />
                  <meta
                    name="description"
                    content="Explore Utah's manufacturing industry with key data on growth, employment, trends, and economic impact. Get insights into Utah's thriving manufacturing sector at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/manufacturing"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah's manufacturing industry with key data on growth, employment, trends, and economic impact. Get insights into Utah's thriving manufacturing sector at UtahData.org."
                  />
                </Helmet>
                <Manufacturing />
              </>
            }
          />
          <Route
            path="/verticals/information"
            element={
              <>
                <Helmet>
                  <title>
                    Utah IT & Information Sector | Data & Growth Trends
                  </title>
                  <meta
                    name="description"
                    content="Explore Utah's Information Technology sector: job growth, companies, and digital innovation. See trends on UtahData.org."
                  />
                  <meta
                    property="og:title"
                    content="Utah IT & Information Sector | Data & Growth Trends"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah's Information Technology sector: job growth, companies, and digital innovation. See trends on UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/information"
                  />
                </Helmet>
                <Information />
              </>
            }
          />
          <Route
            path="/verticals/professional-scientific-and-technical-services"
            element={
              <>
                <Helmet>
                  <title>
                    Top Engineering & Technology Careers in Utah | growth |
                    Opportunities
                  </title>
                  <meta
                    property="og:title"
                    content="Top Engineering & Technology Careers in Utah | growth |
                Opportunities"
                  />
                  <meta
                    name="description"
                    content="Explore Utah engineering industry, a hub of innovation and growth. Discover key trends, job opportunities, top companies, and technological advancements in Utah."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/professional-scientific-and-technical-services"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah engineering industry, a hub of innovation and growth. Discover key trends, job opportunities, top companies, and technological advancements in Utah."
                  />
                </Helmet>
                <EngineeringAndTechnology />
              </>
            }
          />
          <Route
            path="/verticals/food-industry"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Food Industry Insights | Trends, Data | Market Analysis
                  </title>
                  <meta
                    property="og:title"
                    content=" Utah Food Industry Insights | Trends, Data | Market
                      Analysis"
                  />
                  <meta
                    name="description"
                    content="Discover key insights into Utah’s food industry, including market trends, employment data, economic impact, and growth opportunities. Explore more at UtahData.org"
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/food"
                  />
                  <meta
                    property="og:description"
                    content="Discover key insights into Utah’s food industry, including market trends, employment data, economic impact, and growth opportunities. Explore more at UtahData.org"
                  />
                </Helmet>
                <FoodIndustry />
              </>
            }
          />
          {/* <Route
            path="/verticals/transportation-and-warehousing"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Food Industry Insights | Trends, Data | Market Analysis
                  </title>
                  <meta
                    property="og:title"
                    content=" Utah Food Industry Insights | Trends, Data | Market
                      Analysis"
                  />
                  <meta
                    name="description"
                    content="Discover key insights into Utah’s food industry, including market trends, employment data, economic impact, and growth opportunities. Explore more at UtahData.org"
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/food"
                  />
                  <meta
                    property="og:description"
                    content="Discover key insights into Utah’s food industry, including market trends, employment data, economic impact, and growth opportunities. Explore more at UtahData.org"
                  />
                </Helmet>
                <TransportationAndWarehousing />
              </>
            }
          /> */}
          <Route
            path="/verticals/transportation-and-warehousing"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Transportation & Warehousing Industry Insights |
                    Trends, Data | Market Analysis
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Transportation & Warehousing Industry Insights | Trends, Data | Market Analysis"
                  />
                  <meta
                    name="description"
                    content="Explore Utah’s transportation and warehousing industry — key market trends, employment data, logistics insights, and growth opportunities. Stay informed with UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/transportation-and-warehousing"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s transportation and warehousing industry — key market trends, employment data, logistics insights, and growth opportunities. Stay informed with UtahData.org."
                  />
                </Helmet>
                <TransportationAndWarehousing />
              </>
            }
          />

          {/* <Route
            path="/verticals/architecture-and-construction"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Aerospace & Defense | Industry Data | Insights
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Aerospace & Defense | Industry Data | Insights"
                  />
                  <meta
                    name="description"
                    content="Discover insights on Utah's aerospace and defense industry. Explore key data, trends, and statistics shaping innovation and growth in this vital sector."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/aerospace"
                  />
                  <meta
                    property="og:description"
                    content="Discover insights on Utah's aerospace and defense industry. Explore key data, trends, and statistics shaping innovation and growth in this vital sector."
                  />
                </Helmet>
                <Construction />
              </>
            }
          /> */}

          <Route
            path="/verticals/construction"
            element={
              <>
                <Helmet>
                  <title>Utah Construction | Industry Data | Insights</title>
                  <meta
                    property="og:title"
                    content="Utah Construction | Industry Data | Insights"
                  />
                  <meta
                    name="description"
                    content="Explore Utah's construction industry. Discover data, trends, employment statistics, and insights shaping growth and development in this vital sector."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/construction"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah's construction industry. Discover data, trends, employment statistics, and insights shaping growth and development in this vital sector."
                  />
                </Helmet>
                <Construction />
              </>
            }
          />

          <Route
            path="/verticals/aerospace-and-defense"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Aerospace & Defense | Industry Data | Insights
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Aerospace & Defense | Industry Data | Insights"
                  />
                  <meta
                    name="description"
                    content="Discover insights on Utah's aerospace and defense industry. Explore key data, trends, and statistics shaping innovation and growth in this vital sector."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/aerospace"
                  />
                  <meta
                    property="og:description"
                    content="Discover insights on Utah's aerospace and defense industry. Explore key data, trends, and statistics shaping innovation and growth in this vital sector."
                  />
                </Helmet>
                <Aerospace />
              </>
            }
          />

          <Route
            path="/verticals/hill-airforce-base-economic-impact"
            element={
              <>
                <Helmet>
                  <title>
                    Hill AFB Economic Impact | Utah Data | Statistics
                  </title>
                  <meta
                    property="og:title"
                    content="Hill AFB Economic Impact | Utah Data | Statistics"
                  />
                  <meta
                    name="description"
                    content="Hill Air Force Base is an economic powerhouse for Utah. This dashboard highlights the base's economic footprint, workforce contribution, and critical role in national defense and the local economy."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/hill-airforce-base-economic-impact"
                  />
                  <meta
                    property="og:description"
                    content="Hill Air Force Base is an economic powerhouse for Utah. This dashboard highlights the base's economic footprint, workforce contribution, and critical role in national defense and the local economy."
                  />
                </Helmet>
                <HillAFBEconomicImpact />
              </>
            }
          />

          <Route
            path="/verticals/mining"
            element={
              <>
                <Helmet>
                  <title>Utah Mining</title>
                  <meta property="og:title" content="Utah Mining" />
                  <meta
                    name="description"
                    content="Utah’s mining industry plays a vital role in the state’s economy, producing essential resources like copper, coal, gold, and salt."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/verticals/mining"
                  />
                  <meta
                    property="og:description"
                    content="Utah’s mining industry plays a vital role in the state’s economy, producing essential resources like copper, coal, gold, and salt."
                  />
                </Helmet>
                <Mining />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Data at a Glance: Comprehensive State Statistics |
                    Insights
                  </title>
                  <meta
                    property="og:title"
                    content="Utah At a Glance: Comprehensive State Statistics |
                      Insights"
                  />
                  <meta
                    name="description"
                    content="Discover Utah At a Glance with key insights on places to visit, Jobs, top universities, Schools in Utah, and Total Population."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah At a Glance with key insights on places to visit, Jobs, top universities, Schools in Utah, and Total Population."
                  />
                </Helmet>
                <UtahAtAGlance />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/charging-stations"
            element={
              <>
                <Helmet>
                  <title>
                    Utah EV Charging Stations | Locations | Availability
                  </title>
                  <meta
                    property="og:title"
                    content="Utah EV Charging Stations | Locations | Availability"
                  />
                  <meta
                    name="description"
                    content="Find Utah EV charging stations by location and accessibility. Explore charging options for electric vehicles statewide at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/charging"
                  />
                  <meta
                    property="og:description"
                    content="Find Utah EV charging stations by location and accessibility. Explore charging options for electric vehicles statewide at UtahData.org."
                  />
                </Helmet>
                <UtahChargingStation />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-charging-stations"
            element={
              <>
                <Helmet>
                  <title>
                    Utah EV Charging Stations | Locations | Availability
                  </title>
                  <meta
                    property="og:title"
                    content="Utah EV Charging Stations | Locations | Availability"
                  />
                  <meta
                    name="description"
                    content="Find Utah EV charging stations by location and accessibility. Explore charging options for electric vehicles statewide at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/charging"
                  />
                  <meta
                    property="og:description"
                    content="Find Utah EV charging stations by location and accessibility. Explore charging options for electric vehicles statewide at UtahData.org."
                  />
                </Helmet>
                <UtahChargingStation />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-housing"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Housing | Market Trends | Prices | Living Insights
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Housing | Market Trends | Prices | Living Insights"
                  />

                  <meta
                    name="description"
                    content="Explore Utah’s housing market trends, home prices, and living insights. Get updates on real estate and affordability at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-housing"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s housing market trends, home prices, and living insights. Get updates on real estate and affordability at UtahData.org."
                  />
                </Helmet>
                <UtahHousing />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-governor"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Governor | Leadership | Policies | Updates | UtahData
                  </title>
                  <meta
                    property="og:title"
                    content="  Utah Governor | Leadership | Policies | Updates | UtahData"
                  />

                  <meta
                    name="description"
                    content="Discover the Utah Governor’s leadership, policies, and government updates. Stay informed on governance and state initiatives at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/utah-governor"
                  />
                  <meta
                    property="og:description"
                    content="Discover the Utah Governor’s leadership, policies, and government updates. Stay informed on governance and state initiatives at UtahData.org."
                  />
                </Helmet>
                <UtahGovernor />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-counties"
            element={
              <>
                <Helmet>
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-counties"
                  />
                </Helmet>
                <UtahCounties />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-voters-count"
            element={
              <>
                <Helmet>
                  <title>Utah Voters Count | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Utah Voters Count | UtahData.org"
                  />

                  <meta
                    name="description"
                    content="Utah's active and non-active voter counts and trends. Stay updated with the latest voter data on UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-voters-count"
                  />
                  <meta
                    property="og:description"
                    content="Utah's active and non-active voter counts and trends. Stay updated with the latest voter data on UtahData.org."
                  />
                </Helmet>
                <UtahVotersCount />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/universities-and-schools"
            element={
              <>
                <Helmet>
                  <title>Utah Universities and Schools | Learning Insights</title>
                  <meta
                    name="description"
                    content="Explore universities and schools across Utah. Get academic trends and education insights here."
                  />
                  <meta
                    property="og:title"
                    content="Utah Universities and Schools | Learning Insights"
                  />
                  <meta
                    property="og:description"
                    content="Explore universities and schools across Utah. Get academic trends and education insights here."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/universities-and-schools"
                  />
                </Helmet>
                <EducationResources />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-universities-and-schools"
            element={
              <>
                <Helmet>
                  <title>Utah Universities and Schools | Learning Insights</title>
                  <meta
                    name="description"
                    content="Explore universities and schools across Utah. Get academic trends and education insights here."
                  />
                  <meta
                    property="og:title"
                    content="Utah Universities and Schools | Learning Insights"
                  />
                  <meta
                    property="og:description"
                    content="Explore universities and schools across Utah. Get academic trends and education insights here."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/universities-and-schools"
                  />
                </Helmet>
                <EducationResources />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/universities-and-schools/utah-schools"
            element={
              <>
                <Helmet>
                  <title>
                    Top-Ranked Utah Schools Data | Public, Charter | Private
                    School Ratings
                  </title>
                  <meta
                    property="og:title"
                    content=" Top-Ranked Utah Schools Data | Public, Charter | Private
                School Ratings"
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/universities-and-schools/utah-schools"
                  />
                  <meta
                    name="description"
                    content="Explore top-ranked Utah schools Data, Find ratings for public, charter, and private institutions to choose the best educational options for your child"
                  />
                  <meta
                    property="og:description"
                    content="Explore top-ranked Utah schools Data, Find ratings for public, charter, and private institutions to choose the best educational options for your child"
                  />
                </Helmet>
                <UtahSchools />
              </>
            }
          />


          <Route
            path="/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools"
            element={
              <>
                <Helmet>
                  <title>Utah Charter Schools | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Utah Charter Schools | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Explore the number of charter schools in Utah by county. Find detailed statistics and insights on charter education options across the state."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools"
                  />
                  <meta
                    property="og:description"
                    content="Explore the number of charter schools in Utah by county. Find detailed statistics and insights on charter education options across the state."
                  />
                </Helmet>
                <CharteredSchools />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/universities-and-schools/utah-schools/:districtSlug"
            element={
              <>
                {" "}
                <Helmet>
                  <title>
                    Top-Ranked Utah Schools Data | Public, Charter | Private
                    School Ratings
                  </title>
                  <meta
                    property="og:title"
                    content=" Top-Ranked Utah Schools Data | Public, Charter | Private
                School Ratings"
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/universities-and-schools/utah-schools"
                  />
                  <meta
                    name="description"
                    content="Explore top-ranked Utah schools Data, Find ratings for public, charter, and private institutions to choose the best educational options for your child"
                  />
                  <meta
                    property="og:description"
                    content="Explore top-ranked Utah schools Data, Find ratings for public, charter, and private institutions to choose the best educational options for your child"
                  />
                </Helmet>
                <SchoolDistrict />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-cities"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Cities Data & Statistics | Population | Growth Insight
                  </title>
                  <meta
                    property="og:title"
                    content=" Utah Cities Data & Statistics | Population | Growth
                Insight"
                  />
                  <meta
                    name="description"
                    content="Explore key insights on Utah cities, including population, economy, demographics, and growth trends. Discover data-driven facts about major cities in Utah at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/geographic-insights/utah-cities"
                  />
                  <meta
                    property="og:description"
                    content="Explore key insights on Utah cities, including population, economy, demographics, and growth trends. Discover data-driven facts about major cities in Utah at UtahData.org."
                  />
                </Helmet>
                <UtahCities />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/demographics"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Demographics & Population Trends | Insights
                  </title>
                  <meta
                    name="description"
                    content="Discover key demographic stats and population breakdowns of Utah. Get interactive data on age, race, gender, and more."
                  />
                  <meta
                    property="og:title"
                    content="Utah Demographics & Population Trends | Insights"
                  />
                  <meta
                    property="og:description"
                    content="Discover key demographic stats and population breakdowns of Utah. Get interactive data on age, race, gender, and more."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/demographics"
                  />
                </Helmet>
                <PopulationDemography />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-demographics"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Demographics & Population Trends | Insights
                  </title>
                  <meta
                    name="description"
                    content="Discover key demographic stats and population breakdowns of Utah. Get interactive data on age, race, gender, and more."
                  />
                  <meta
                    property="og:title"
                    content="Utah Demographics & Population Trends | Insights"
                  />
                  <meta
                    property="og:description"
                    content="Discover key demographic stats and population breakdowns of Utah. Get interactive data on age, race, gender, and more."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/demographics"
                  />
                </Helmet>
                <PopulationDemography />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-employment"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Job Market Trends | Employment Data | Industry Insights
                  </title>
                  <meta
                    property="og:title"
                    content=" Utah Job Market Trends | Employment Data | Industry
                      Insights"
                  />
                  <meta
                    name="description"
                    content="Explore Utah’s job market with insights on employment trends, top industries, salaries, and career opportunities. Stay updated on workforce data at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/employment-and-economy/utah-jobs"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s job market with insights on employment trends, top industries, salaries, and career opportunities. Stay updated on workforce data at UtahData.org."
                  />
                </Helmet>
                <UtahJobs />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/unemployment-rate"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Unemployment Rate | Trends, Statistics | Economic
                    Insights
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Unemployment Rate | Trends, Statistics | Economic
                Insights"
                  />
                  <meta
                    name="description"
                    content="Discover the latest Utah unemployment rate trends, statistics, and insights. Stay updated with comprehensive data and analysis on Utah's job market."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/employment-and-economy/utah-unemployment-rate"
                  />
                  <meta
                    property="og:description"
                    content="Discover the latest Utah unemployment rate trends, statistics, and insights. Stay updated with comprehensive data and analysis on Utah's job market."
                  />
                </Helmet>
                <UnemploymentRate />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-unemployment-rate"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Unemployment Rate | Trends, Statistics | Economic
                    Insights
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Unemployment Rate | Trends, Statistics | Economic
                Insights"
                  />
                  <meta
                    name="description"
                    content="Discover the latest Utah unemployment rate trends, statistics, and insights. Stay updated with comprehensive data and analysis on Utah's job market."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/employment-and-economy/utah-unemployment-rate"
                  />
                  <meta
                    property="og:description"
                    content="Discover the latest Utah unemployment rate trends, statistics, and insights. Stay updated with comprehensive data and analysis on Utah's job market."
                  />
                </Helmet>
                <UnemploymentRate />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-geothermal-hotspots"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Geothermal Hotspots | Explore Renewable Energy Sources
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Geothermal Hotspots | Explore Renewable Energy
                Sources"
                  />
                  <meta
                    name="description"
                    content="Explore Utah's geothermal hotspots, harnessing natural heat for sustainable energy. Learn about geothermal power plants and their impact on Utah's energy landscape."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/energy-resources/utah-geothermal-hotspots"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah's geothermal hotspots, harnessing natural heat for sustainable energy. Learn about geothermal power plants and their impact on Utah's energy landscape."
                  />
                </Helmet>
                <GeothermalMap />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-airports"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Airports & Heliports | Locations | Travel Info
                  </title>
                  <meta
                    property="og:title"
                    content="   Utah Airports & Heliports | Locations | Travel Info"
                  />

                  <meta
                    name="description"
                    content="Find details on Utah airports and heliports, including locations, facilities, and travel information. Explore aviation data at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/transportation-and-infrastructure/utah-airports-heliports"
                  />
                  <meta
                    property="og:description"
                    content="Find details on Utah airports and heliports, including locations, facilities, and travel information. Explore aviation data at UtahData.org."
                  />
                </Helmet>
                <Airports />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-operation-gigawatt"
            element={
              <>
                <Helmet>
                  <title>
                    Operation Gigawatt | Utah Power Grid | Energy Infrastructure
                  </title>
                  <meta
                    property="og:title"
                    content="Operation Gigawatt | Utah Power Grid | Energy Infrastructure"
                  />
                  <meta
                    name="description"
                    content="Explore Operation Gigawatt - Utah's comprehensive energy initiative to double power generation capacity by 2034. Discover nuclear, geothermal, and hydrogen projects transforming Utah's energy landscape."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/utahpowergrid"
                  />
                  <meta
                    property="og:description"
                    content="Explore Operation Gigawatt - Utah's comprehensive energy initiative to double power generation capacity by 2034. Discover nuclear, geothermal, and hydrogen projects transforming Utah's energy landscape."
                  />
                </Helmet>
                <UtahPowergrid />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/mlm"
            element={
              <>
                <Helmet>
                  <title>
                    Utah MLM | Multi-Level Marketing Companies | Insights
                  </title>
                  <meta
                    property="og:title"
                    content=" Utah MLM | Multi-Level Marketing Companies | Insights"
                  />
                  <meta
                    name="description"
                    content="Discover Utah’s multi-level marketing (MLM) industry, top companies, business insights, and its economic impact. Explore MLM data at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/employment-and-economy/utah-mlm"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah’s multi-level marketing (MLM) industry, top companies, business insights, and its economic impact. Explore MLM data at UtahData.org."
                  />
                </Helmet>
                <MLM />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-mlm"
            element={
              <>
                <Helmet>
                  <title>
                    Utah MLM | Multi-Level Marketing Companies | Insights
                  </title>
                  <meta
                    property="og:title"
                    content=" Utah MLM | Multi-Level Marketing Companies | Insights"
                  />
                  <meta
                    name="description"
                    content="Discover Utah’s multi-level marketing (MLM) industry, top companies, business insights, and its economic impact. Explore MLM data at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/employment-and-economy/utah-mlm"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah’s multi-level marketing (MLM) industry, top companies, business insights, and its economic impact. Explore MLM data at UtahData.org."
                  />
                </Helmet>
                <MLM />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/hospitals"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Hospitals | Locations | Services | Healthcare Info
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Hospitals | Locations | Services | Healthcare Info"
                  />

                  <meta
                    name="description"
                    content="Explore Utah hospitals, their locations, services, and healthcare facilities. Find essential medical resources at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-hospitals"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah hospitals, their locations, services, and healthcare facilities. Find essential medical resources at UtahData.org."
                  />
                </Helmet>
                <Hospital />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-hospitals"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Hospitals | Locations | Services | Healthcare Info
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Hospitals | Locations | Services | Healthcare Info"
                  />

                  <meta
                    name="description"
                    content="Explore Utah hospitals, their locations, services, and healthcare facilities. Find essential medical resources at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-hospitals"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah hospitals, their locations, services, and healthcare facilities. Find essential medical resources at UtahData.org."
                  />
                </Helmet>
                <Hospital />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-nonprofits"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Non-Profits | Organizations Directory | UtahData.org
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Non-Profits | Organizations Directory | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Explore Utah non-profit organizations dedicated to serving communities, protecting the environment, and supporting vulnerable populations across the state."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-nonprofits"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah non-profit organizations making a difference in communities, environment, and social services across the Beehive State."
                  />
                </Helmet>
                <NonProfits />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Nonprofits Association (UNA) | Dashboard | UtahData.org
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Nonprofits Association (UNA) | Dashboard | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Explore Utah's nonprofit ecosystem through comprehensive data and visual insights from the Utah Nonprofits Association (UNA)."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-nonprofits/dashboard"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah's nonprofit landscape with key metrics, statistics, and insights from the Utah Nonprofits Association (UNA)."
                  />
                </Helmet>
                <UnaLandingDashboard />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/air-quality-index"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Air Quality Index | Real-Time AQI Data | UtahData.org
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Air Quality Index | Real-Time AQI Data | UtahData.org"
                  />

                  <meta
                    name="description"
                    content="Check Utah's real-time Air Quality Index (AQI) on UtahData.org. Stay informed about air pollution levels and breathe healthier with up-to-date data."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/air-quality-index"
                  />
                  <meta
                    property="og:description"
                    content="Check Utah's real-time Air Quality Index (AQI) on UtahData.org. Stay informed about air pollution levels and breathe healthier with up-to-date data."
                  />
                </Helmet>
                <AirQuality />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-air-quality-index"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Air Quality Index | Real-Time AQI Data | UtahData.org
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Air Quality Index | Real-Time AQI Data | UtahData.org"
                  />

                  <meta
                    name="description"
                    content="Check Utah's real-time Air Quality Index (AQI) on UtahData.org. Stay informed about air pollution levels and breathe healthier with up-to-date data."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/air-quality-index"
                  />
                  <meta
                    property="og:description"
                    content="Check Utah's real-time Air Quality Index (AQI) on UtahData.org. Stay informed about air pollution levels and breathe healthier with up-to-date data."
                  />
                </Helmet>
                <AirQuality />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/taxes"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Tax Overview | Income, Sales & Property Taxes
                  </title>
                  <meta
                    name="description"
                    content="Learn about Utah's tax structure—income, sales, property, and more with updated statistics."
                  />
                  <meta
                    property="og:title"
                    content="Utah Tax Overview | Income, Sales & Property Taxes"
                  />
                  <meta
                    property="og:description"
                    content="Learn about Utah's tax structure—income, sales, property, and more with updated statistics."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/tax"
                  />
                </Helmet>
                <Tax />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-taxes"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Tax Overview | Income, Sales & Property Taxes
                  </title>
                  <meta
                    name="description"
                    content="Learn about Utah's tax structure—income, sales, property, and more with updated statistics."
                  />
                  <meta
                    property="og:title"
                    content="Utah Tax Overview | Income, Sales & Property Taxes"
                  />
                  <meta
                    property="og:description"
                    content="Learn about Utah's tax structure—income, sales, property, and more with updated statistics."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/tax"
                  />
                </Helmet>
                <Tax />
              </>
            }
          />
          {/* <Route
            path="/utah-at-a-glance/culture"
            element={
              <>
                <Helmet>
                  <title>Utah Culture | Festivals, Religion & History</title>
                  <meta
                    name="description"
                    content="Discover the cultural diversity of Utah through traditions, religious affiliations, and historical roots."
                  />
                  <meta
                    property="og:title"
                    content="Utah Culture | Festivals, Religion & History"
                  />
                  <meta
                    property="og:description"
                    content="Discover the cultural diversity of Utah through traditions, religious affiliations, and historical roots."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/culture"
                  />
                </Helmet>
                <DashboardLayoutBasic />
              </>
            }
          /> */}

          {/* <Route
            path="/utah-at-a-glance/utah-culture"
            element={
              <>
                <Helmet>
                  <title>Utah Culture | Festivals, Religion & History</title>
                  <meta
                    name="description"
                    content="Discover the cultural diversity of Utah through traditions, religious affiliations, and historical roots."
                  />
                  <meta
                    property="og:title"
                    content="Utah Culture | Festivals, Religion & History"
                  />
                  <meta
                    property="og:description"
                    content="Discover the cultural diversity of Utah through traditions, religious affiliations, and historical roots."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/culture"
                  />
                </Helmet>
                <DashboardLayoutBasic />
              </>
            }
          /> */}
          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-stateparks"
            element={
              <>
                <Helmet>
                  <title>
                    Top-Rated Utah State Parks | Hiking, Camping | Outdoor
                    Adventures
                  </title>
                  <meta
                    property="og:title"
                    content="Top-Rated Utah State Parks | Hiking, Camping | Outdoor
                Adventures"
                  />
                  <meta
                    name="description"
                    content="Discover Utah's stunning state parks, offering breathtaking landscapes, outdoor adventures, and family-friendly activities.Explore Utah Data To Know More."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-stateparks"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah's stunning state parks, offering breathtaking landscapes, outdoor adventures, and family-friendly activities.Explore Utah Data To Know More."
                  />
                </Helmet>
                <StateParks />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-nationalparks"
            element={
              <>
                <Helmet>
                  <title>
                    Explore Utah's National Parks Data | Top-Rated Arches |
                    Bryce Canyon
                  </title>
                  <meta
                    property="og:title"
                    content="Explore Utah's National Parks Data | Top-Rated Arches |
                Bryce Canyon"
                  />
                  <meta
                    name="description"
                    content="Discover Utah's top national parks, including Arches, Bryce Canyon, and Zion. Explore stunning landscapes, hiking trails, and unique geological formations."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-nationalparks"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah's top national parks, including Arches, Bryce Canyon, and Zion. Explore stunning landscapes, hiking trails, and unique geological formations."
                  />
                </Helmet>
                <NationalPark />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/federal-agencies"
            element={
              <>
                <Helmet>
                  <title>Utah State Agencies & Institutions | Directory</title>
                  <meta
                    name="description"
                    content="Explore the list of Utah government agencies, public offices, and institutional directories with data-driven insights."
                  />
                  <meta
                    property="og:title"
                    content="Utah State Agencies & Institutions | Directory"
                  />
                  <meta
                    property="og:description"
                    content="Explore the list of Utah government agencies, public offices, and institutional directories with data-driven insights."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/federal-agency"
                  />
                </Helmet>
                <AgencyCards />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-federal-agencies"
            element={
              <>
                <Helmet>
                  <title>Utah State Agencies & Institutions | Directory</title>
                  <meta
                    name="description"
                    content="Explore the list of Utah government agencies, public offices, and institutional directories with data-driven insights."
                  />
                  <meta
                    property="og:title"
                    content="Utah State Agencies & Institutions | Directory"
                  />
                  <meta
                    property="og:description"
                    content="Explore the list of Utah government agencies, public offices, and institutional directories with data-driven insights."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/federal-agency"
                  />
                </Helmet>
                <AgencyCards />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/sports-club"
            element={
              <>
                <Helmet>
                  <title>Utah Sports | Teams, Events & Athletic Trends</title>
                  <meta
                    name="description"
                    content="Explore Utah’s athletic scene—college sports, pro teams, and major events across the state."
                  />
                  <meta
                    property="og:title"
                    content="Utah Sports | Teams, Events & Athletic Trends"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s athletic scene—college sports, pro teams, and major events across the state."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/sports"
                  />
                </Helmet>
                <Sports />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-sports-club"
            element={
              <>
                <Helmet>
                  <title>Utah Sports | Teams, Events & Athletic Trends</title>
                  <meta
                    name="description"
                    content="Explore Utah’s athletic scene—college sports, pro teams, and major events across the state."
                  />
                  <meta
                    property="og:title"
                    content="Utah Sports | Teams, Events & Athletic Trends"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s athletic scene—college sports, pro teams, and major events across the state."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/sports"
                  />
                </Helmet>
                <Sports />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/adventure-activities"
            element={
              <>
                <Helmet>
                  <title>
                    Adventure in Utah | Outdoor Activities & Tourism
                  </title>
                  <meta
                    name="description"
                    content="Uncover thrilling outdoor adventures in Utah from skiing and hiking to rock climbing and rafting."
                  />
                  <meta
                    property="og:title"
                    content="Adventure in Utah | Outdoor Activities & Tourism"
                  />
                  <meta
                    property="og:description"
                    content="Uncover thrilling outdoor adventures in Utah from skiing and hiking to rock climbing and rafting."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/adventure"
                  />
                </Helmet>
                <Adventure />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-adventure-activities"
            element={
              <>
                <Helmet>
                  <title>
                    Adventure in Utah | Outdoor Activities & Tourism
                  </title>
                  <meta
                    name="description"
                    content="Uncover thrilling outdoor adventures in Utah from skiing and hiking to rock climbing and rafting."
                  />
                  <meta
                    property="og:title"
                    content="Adventure in Utah | Outdoor Activities & Tourism"
                  />
                  <meta
                    property="og:description"
                    content="Uncover thrilling outdoor adventures in Utah from skiing and hiking to rock climbing and rafting."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/adventure"
                  />
                </Helmet>
                <Adventure />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/hill-airforce-base"
            element={
              <>
                <Helmet>
                  <title>Utah Air Force Bases & Defense Presence</title>
                  <meta
                    name="description"
                    content="Learn about Utah’s Air Force and defense operations including base locations and contributions to national security."
                  />
                  <meta
                    property="og:title"
                    content="Utah Air Force Bases & Defense Presence"
                  />
                  <meta
                    property="og:description"
                    content="Learn about Utah’s Air Force and defense operations including base locations and contributions to national security."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/hill-airforce-base"
                  />
                </Helmet>
                <Airforce />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-hill-airforce-base"
            element={
              <>
                <Helmet>
                  <title>Utah Air Force Bases & Defense Presence</title>
                  <meta
                    name="description"
                    content="Learn about Utah’s Air Force and defense operations including base locations and contributions to national security."
                  />
                  <meta
                    property="og:title"
                    content="Utah Air Force Bases & Defense Presence"
                  />
                  <meta
                    property="og:description"
                    content="Learn about Utah’s Air Force and defense operations including base locations and contributions to national security."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/hill-airforce-base"
                  />
                </Helmet>
                <Airforce />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit"
            element={<PlacesToVisit />}
          />

          <Route
            path="/betsy"
            element={
              <>
                <Helmet>
                  <title>
                    Meet Betsy | AI Chatbot for Instant Queries & Assistance
                  </title>
                  <meta
                    property="og:title"
                    content="   Meet Betsy | AI Chatbot for Instant Queries & Assistance"
                  />
                  <meta
                    name="description"
                    content="Meet Betsy at UtahData.org—your guide to Utah’s data insights. Explore trends in demographics, economy, and more with user-friendly, interactive analytics."
                  />
                  <link rel="canonical" href="https://utahdata.org/betsy" />
                  <meta
                    property="og:description"
                    content="Meet Betsy at UtahData.org—your guide to Utah’s data insights. Explore trends in demographics, economy, and more with user-friendly, interactive analytics."
                  />
                </Helmet>
                <AskBetsyAI />
              </>
            }
          />
          <Route
            path="/search"
            element={
              <>
                <Helmet>
                  <title>
                    Meet Betsy | AI Chatbot for Instant Queries & Assistance
                  </title>
                  <meta
                    property="og:title"
                    content="   Meet Betsy | AI Chatbot for Instant Queries & Assistance"
                  />
                  <meta
                    name="description"
                    content="Meet Betsy at UtahData.org—your guide to Utah’s data insights. Explore trends in demographics, economy, and more with user-friendly, interactive analytics."
                  />
                  <link rel="canonical" href="https://utahdata.org/betsy" />
                  <meta
                    property="og:description"
                    content="Meet Betsy at UtahData.org—your guide to Utah’s data insights. Explore trends in demographics, economy, and more with user-friendly, interactive analytics."
                  />
                </Helmet>
                <AskBetsyAI />
              </>
            }
          />
          {/* <Route path="/contact" element={<ContactForm />} /> */}
          <Route
            path="/contact-us"
            element={
              <>
                <Helmet>
                  <title>Contact Us | Get in Touch with Utah Data Team</title>
                  <meta
                    property="og:title"
                    content="Contact Us | Get in Touch with Utah Data Team"
                  />
                  <meta
                    name="description"
                    content="Contact UtahData.org for inquiries, support, and feedback. We're here to help you access valuable data insights and hear your thoughts on Utah’s dynamic growth."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/contact-us"
                  />
                  <meta
                    property="og:description"
                    content="Contact UtahData.org for inquiries, support, and feedback. We're here to help you access valuable data insights and hear your thoughts on Utah’s dynamic growth."
                  />
                </Helmet>
                <Contactai />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <Helmet>
                  <title>
                    About UtahData.org | Explore Utah Data | Trends | Insights
                  </title>
                  <meta
                    property="og:title"
                    content="About UtahData.org | Explore Utah Data | Trends | Insights"
                  />
                  <meta
                    name="description"
                    content="UtahData.org empowers Utahns with interactive, user-friendly data insights that highlight our state's rich diversity and dynamic growth."
                  />
                  <link rel="canonical" href="https://utahdata.org/about" />
                  <meta
                    property="og:description"
                    content="UtahData.org empowers Utahns with interactive, user-friendly data insights that highlight our state's rich diversity and dynamic growth."
                  />
                </Helmet>
                <About />
              </>
            }
          />

          <Route
            path="/gallery"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Gallery | Capturing the Spirit of the Beehive State
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Gallery | Capturing the Spirit of the Beehive State"
                  />
                  <meta
                    name="description"
                    content="Utah Gallery featuring stunning, high-quality images captured by passionate photographers across Utah. Discover scenic landscapes, cityscapes, and iconic moments that showcase the beauty of the Beehive State."
                  />
                  <link rel="canonical" href="https://utahdata.org/gallery" />
                  <meta
                    property="og:description"
                    content="Utah Gallery featuring stunning, high-quality images captured by passionate photographers across Utah. Discover scenic landscapes, cityscapes, and iconic moments that showcase the beauty of the Beehive State."
                  />
                </Helmet>
                <Gallery />
              </>
            }
          />

          <Route
            path="/sitemap2"
            element={
              <>
                <Helmet>
                  <title>
                    UtahData.org Sitemap V2 | Full Page Directory & Sections
                  </title>
                  <meta
                    property="og:title"
                    content="UtahData.org Sitemap V2 | Full Page Directory & Sections"
                  />
                  <meta
                    name="description"
                    content="View the complete list of pages and categories across UtahData.org using Sitemap version 2."
                  />
                  <meta
                    property="og:description"
                    content="View the complete list of pages and categories across UtahData.org using Sitemap version 2."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/sitemap2"
                  />
                </Helmet>
                <SiteMapPage />
              </>
            }
          />

          <Route
            path="/sitemap"
            element={
              <>
                <Helmet>
                  <title>
                    UtahData.org Sitemap | Navigate All Pages & Categories
                  </title>
                  <meta
                    property="og:title"
                    content="UtahData.org Sitemap | Navigate All Pages & Categories"
                  />
                  <meta
                    name="description"
                    content="Explore every page and section of UtahData.org through this complete and organized sitemap."
                  />
                  <meta
                    property="og:description"
                    content="Explore every page and section of UtahData.org through this complete and organized sitemap."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/sitemap"
                  />
                </Helmet>
                <SiteMap2 />
              </>
            }
          />

          <Route
            path="/sp"
            element={
              <>
                <Helmet>
                  <title>
                    Sumit Parashar | CEO of BODEX & UtahData.org | Business Card
                  </title>
                  <meta
                    property="og:title"
                    content="Sumit Parashar | CEO of BODEX & UtahData.org | Business Card"
                  />
                  <meta
                    name="description"
                    content="Official business profile of Sumit Parashar, CEO of BODEX and UtahData.org. Contact, email, and services."
                  />
                  <meta
                    property="og:description"
                    content="Official business profile of Sumit Parashar, CEO of BODEX and UtahData.org. Contact, email, and services."
                  />
                  <link rel="canonical" href="https://www.utahdata.org/sp" />
                </Helmet>
                <Sp />
              </>
            }
          />

          <Route
            path="/founders-note"
            element={
              <>
                <Helmet>
                  <title>Founder's Note | Vision Behind UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Founder's Note | Vision Behind UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Read the founder's message on the mission, inspiration, and vision that shaped UtahData.org."
                  />
                  <meta
                    property="og:description"
                    content="Read the founder's message on the mission, inspiration, and vision that shaped UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/founders-note"
                  />
                </Helmet>
                <FounderNote />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-state"
            element={
              <>
                <Helmet>
                  <title>
                    Utah State Overview | Counties & Districts | UtahData
                  </title>
                  <meta
                    name="description"
                    content="Explore the full Utah state map with detailed data on counties, regions, and boundaries. Get geographic and administrative insights."
                  />
                  <meta
                    property="og:title"
                    content="Utah State Overview | Counties & Districts | UtahData"
                  />
                  <meta
                    property="og:description"
                    content="Explore the full Utah state map with detailed data on counties, regions, and boundaries. Get geographic and administrative insights."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-state"
                  />
                </Helmet>
                <UtahState />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/unemployment-rate/dataset"
            element={
              <>
                <Helmet>
                  <title>
                    Unemployment Dataset | Utah Job Market Statistics
                  </title>
                  <meta
                    name="description"
                    content="Access the detailed dataset of unemployment rates in Utah by year, region, and sector. Data powered by UtahData.org."
                  />
                  <meta
                    property="og:title"
                    content="Unemployment Dataset | Utah Job Market Statistics"
                  />
                  <meta
                    property="og:description"
                    content="Access the detailed dataset of unemployment rates in Utah by year, region, and sector. Data powered by UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/unemployment-rate/dataset"
                  />
                </Helmet>
                <DataSet />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/culture/religious"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Religious Culture | Faith, Diversity & Influence
                  </title>
                  <meta
                    name="description"
                    content="Explore the religious diversity of Utah, including faith-based trends, community data, and spiritual influence across the state."
                  />
                  <meta
                    property="og:title"
                    content="Utah Religious Culture | Faith, Diversity & Influence"
                  />
                  <meta
                    property="og:description"
                    content="Explore the religious diversity of Utah, including faith-based trends, community data, and spiritual influence across the state."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/culture/religious"
                  />
                </Helmet>
                <CultReligious />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/culture/history"
            element={
              <>
                <Helmet>
                  <title>
                    Utah History & Heritage | Cultural Timeline & Roots
                  </title>
                  <meta
                    name="description"
                    content="Discover Utah’s historical roots and cultural milestones. Explore timelines, key events, and stories shaping Utah’s legacy."
                  />
                  <meta
                    property="og:title"
                    content="Utah History & Heritage | Cultural Timeline & Roots"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah’s historical roots and cultural milestones. Explore timelines, key events, and stories shaping Utah’s legacy."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/culture/history"
                  />
                </Helmet>
                <CultHistory />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/culture/festival"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Festivals & Celebrations | Events Across the State
                  </title>
                  <meta
                    name="description"
                    content="Celebrate Utah’s cultural richness through its festivals and community events. Discover statewide celebrations, parades, and traditions."
                  />
                  <meta
                    property="og:title"
                    content="Utah Festivals & Celebrations | Events Across the State"
                  />
                  <meta
                    property="og:description"
                    content="Celebrate Utah’s cultural richness through its festivals and community events. Discover statewide celebrations, parades, and traditions."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/culture/festival"
                  />
                </Helmet>
                <CultFestival />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/places-to-visit"
            element={
              <>
                <Helmet>
                  <title>
                    Places to Visit in Utah | Attractions & Scenic Spots
                  </title>
                  <meta
                    name="description"
                    content="Discover must-visit attractions across Utah—from national parks to hidden scenic gems. Explore travel-worthy destinations statewide."
                  />
                  <meta
                    property="og:title"
                    content="Places to Visit in Utah | Attractions & Scenic Spots"
                  />
                  <meta
                    property="og:description"
                    content="Discover must-visit attractions across Utah—from national parks to hidden scenic gems. Explore travel-worthy destinations statewide."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/places-to-visit"
                  />
                </Helmet>
                <PlacesToVisit />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit"
            element={
              <>
                <Helmet>
                  <title>
                    Places to Visit in Utah | Attractions & Scenic Spots
                  </title>
                  <meta
                    name="description"
                    content="Discover must-visit attractions across Utah—from national parks to hidden scenic gems. Explore travel-worthy destinations statewide."
                  />
                  <meta
                    property="og:title"
                    content="Places to Visit in Utah | Attractions & Scenic Spots"
                  />
                  <meta
                    property="og:description"
                    content="Discover must-visit attractions across Utah—from national parks to hidden scenic gems. Explore travel-worthy destinations statewide."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/places-to-visit"
                  />
                </Helmet>
                <PlacesToVisit />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/national-forests"
            element={
              <>
                <Helmet>
                  <title>
                    Utah National Forests | Nature, Trails & Exploration
                  </title>
                  <meta
                    name="description"
                    content="Discover Utah's stunning national forests, hiking trails, scenic routes, and biodiversity. Perfect for explorers and nature lovers."
                  />
                  <meta
                    property="og:title"
                    content="Utah National Forests | Nature, Trails & Exploration"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah's stunning national forests, hiking trails, scenic routes, and biodiversity. Perfect for explorers and nature lovers."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/national-forests"
                  />
                </Helmet>
                <PlacesNationalForest />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/national-monument"
            element={
              <>
                <Helmet>
                  <title>
                    Utah National Monuments | Cultural & Historic Sites
                  </title>
                  <meta
                    name="description"
                    content="Explore Utah's protected national monuments rich with history, culture, and natural beauty. See locations and facts at UtahData.org."
                  />
                  <meta
                    property="og:title"
                    content="Utah National Monuments | Cultural & Historic Sites"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah's protected national monuments rich with history, culture, and natural beauty. See locations and facts at UtahData.org."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/national-monument"
                  />
                </Helmet>
                <PlaceMonument />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/national-wildlife-refuges"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Wildlife Refuges | Conservation & Birdwatching
                  </title>
                  <meta
                    name="description"
                    content="Explore Utah’s national wildlife refuges—sanctuaries for diverse species and birdwatching destinations. Learn about habitat preservation and access details."
                  />
                  <meta
                    property="og:title"
                    content="Utah Wildlife Refuges | Conservation & Birdwatching"
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s national wildlife refuges—sanctuaries for diverse species and birdwatching destinations. Learn about habitat preservation and access details."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/national-wildlife-refuges"
                  />
                </Helmet>
                <PlacesWildlifeRefuges />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/national-recreation-area"
            element={
              <>
                <Helmet>
                  <title>
                    Utah National Recreation Areas | Outdoor Adventure Spots
                  </title>
                  <meta
                    name="description"
                    content="Plan your adventure with Utah’s national recreation areas—offering water sports, hiking, and outdoor fun. Find the top destinations now."
                  />
                  <meta
                    property="og:title"
                    content="Utah National Recreation Areas | Outdoor Adventure Spots"
                  />
                  <meta
                    property="og:description"
                    content="Plan your adventure with Utah’s national recreation areas—offering water sports, hiking, and outdoor fun. Find the top destinations now."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/national-recreation-area"
                  />
                </Helmet>
                <PlacesRecreation />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/national-historic-site"
            element={
              <>
                <Helmet>
                  <title>Utah Historic Sites | Landmarks & Heritage</title>
                  <meta
                    name="description"
                    content="Discover Utah's national historic sites that showcase the rich heritage, architecture, and stories of the state's past."
                  />
                  <meta
                    property="og:title"
                    content="Utah Historic Sites | Landmarks & Heritage"
                  />
                  <meta
                    property="og:description"
                    content="Discover Utah's national historic sites that showcase the rich heritage, architecture, and stories of the state's past."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/national-historic-site"
                  />
                </Helmet>
                <Placeshistory />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/national-forest-services"
            element={
              <>
                <Helmet>
                  <title>
                    National Forest Services in Utah | Preservation & Access
                  </title>
                  <meta
                    name="description"
                    content="Explore the role of National Forest Services in Utah—forest access, environmental preservation, and public use guidelines."
                  />
                  <meta
                    property="og:title"
                    content="National Forest Services in Utah | Preservation & Access"
                  />
                  <meta
                    property="og:description"
                    content="Explore the role of National Forest Services in Utah—forest access, environmental preservation, and public use guidelines."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/national-forest-services"
                  />
                </Helmet>
                <PlacesForestService />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/land-management-wilderness"
            element={
              <>
                <Helmet>
                  <title>
                    Wilderness & Land Management | Utah's Protected Regions
                  </title>
                  <meta
                    name="description"
                    content="Learn about land management and wilderness areas across Utah. Discover protected zones, BLM stewardship, and public access regions."
                  />
                  <meta
                    property="og:title"
                    content="Wilderness & Land Management | Utah's Protected Regions"
                  />
                  <meta
                    property="og:description"
                    content="Learn about land management and wilderness areas across Utah. Discover protected zones, BLM stewardship, and public access regions."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/land-management-wilderness"
                  />
                </Helmet>
                <PlacesLand />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/arches"
            element={
              <>
                <Helmet>
                  <title>
                    Arches National Park | Utah's Iconic Rock Formations
                  </title>
                  <meta
                    name="description"
                    content="Explore Arches National Park in Utah. See iconic natural arches, hiking trails, and park visitor information."
                  />
                  <meta
                    property="og:title"
                    content="Arches National Park | Utah's Iconic Rock Formations"
                  />
                  <meta
                    property="og:description"
                    content="Explore Arches National Park in Utah. See iconic natural arches, hiking trails, and park visitor information."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/arches"
                  />
                </Helmet>
                <NationalPark1 />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/bryce-canyon"
            element={
              <>
                <Helmet>
                  <title>Bryce Canyon | Hoodoos & Scenic Trails in Utah</title>
                  <meta
                    name="description"
                    content="Visit Bryce Canyon National Park to see dramatic hoodoos, hiking paths, and unforgettable views. Learn park access details."
                  />
                  <meta
                    property="og:title"
                    content="Bryce Canyon | Hoodoos & Scenic Trails in Utah"
                  />
                  <meta
                    property="og:description"
                    content="Visit Bryce Canyon National Park to see dramatic hoodoos, hiking paths, and unforgettable views. Learn park access details."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/bryce-canyon"
                  />
                </Helmet>
                <NationalPark2 />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/canyonland"
            element={
              <>
                <Helmet>
                  <title>
                    Canyonlands National Park | Utah's Desert Landscape
                  </title>
                  <meta
                    name="description"
                    content="Explore Canyonlands National Park for its desert scenery, canyon views, and outdoor adventures. View visitor info here."
                  />
                  <meta
                    property="og:title"
                    content="Canyonlands National Park | Utah's Desert Landscape"
                  />
                  <meta
                    property="og:description"
                    content="Explore Canyonlands National Park for its desert scenery, canyon views, and outdoor adventures. View visitor info here."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/canyonland"
                  />
                </Helmet>
                <NationalPark3 />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/capitolreef"
            element={
              <>
                <Helmet>
                  <title>
                    Capitol Reef National Park | Geology & Scenic Drives
                  </title>
                  <meta
                    name="description"
                    content="Discover Capitol Reef National Park—known for colorful cliffs, canyons, and scenic byways. Find trail maps and access tips."
                  />
                  <meta
                    property="og:title"
                    content="Capitol Reef National Park | Geology & Scenic Drives"
                  />
                  <meta
                    property="og:description"
                    content="Discover Capitol Reef National Park—known for colorful cliffs, canyons, and scenic byways. Find trail maps and access tips."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/capitolreef"
                  />
                </Helmet>
                <NationalPark4 />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/zion"
            element={
              <>
                <Helmet>
                  <title>
                    Zion National Park | Canyons, Hikes & Scenic Views
                  </title>
                  <meta
                    name="description"
                    content="Plan your visit to Zion National Park—Utah's popular park featuring majestic canyons, the Narrows, and scenic viewpoints."
                  />
                  <meta
                    property="og:title"
                    content="Zion National Park | Canyons, Hikes & Scenic Views"
                  />
                  <meta
                    property="og:description"
                    content="Plan your visit to Zion National Park—Utah's popular park featuring majestic canyons, the Narrows, and scenic viewpoints."
                  />
                  <link
                    rel="canonical"
                    href="https://utahdata.org/utah-at-a-glance/utah-places-to-visit/utah-nationalparks/zion"
                  />
                </Helmet>
                <NationalPark5 />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/universities-and-schools/utah-universities"
            element={
              <>
                <Helmet>
                  <title>
                    Top-Ranked Utah universities Data | Public, Charter |
                    Private universities Ratings
                  </title>
                  <meta
                    property="og:title"
                    content=" Top-Ranked Utah universities Data | Public, Charter | Private
                universities Ratings"
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/universities-and-schools/utah-universities"
                  />
                  <meta
                    name="description"
                    content="Explore top-ranked Utah universities Data, Find ratings for public, charter, and private institutions to choose the best educational options for your child"
                  />
                  <meta
                    property="og:description"
                    content="Explore top-ranked Utah universities Data, Find ratings for public, charter, and private institutions to choose the best educational options for your child"
                  />
                </Helmet>
                <UtahUniversities />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/zipcodes"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Zip Code Lookup | Find Counties, Cities, and Regions
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Zip Code Lookup | Find Counties, Cities, and Regions"
                  />
                  <meta
                    name="description"
                    content="Search Utah ZIP codes to find counties, cities, and demographics by location with ease."
                  />
                  <meta
                    property="og:description"
                    content="Search Utah ZIP codes to find counties, cities, and demographics by location with ease."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/zipcodes"
                  />
                </Helmet>
                <Zipcode />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-zipcodes"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Zip Code Lookup | Find Counties, Cities, and Regions
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Zip Code Lookup | Find Counties, Cities, and Regions"
                  />
                  <meta
                    name="description"
                    content="Search Utah ZIP codes to find counties, cities, and demographics by location with ease."
                  />
                  <meta
                    property="og:description"
                    content="Search Utah ZIP codes to find counties, cities, and demographics by location with ease."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/zipcodes"
                  />
                </Helmet>
                <Zipcode />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/financial-institutions"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Financial Institutions | Banks, Credit Unions,
                    Investment
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Financial Institutions | Banks, Credit Unions, Investment"
                  />
                  <meta
                    name="description"
                    content="Discover top Utah financial institutions, banks, and credit unions with trusted services."
                  />
                  <meta
                    property="og:description"
                    content="Discover top Utah financial institutions, banks, and credit unions with trusted services."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/financial-institutions"
                  />
                </Helmet>
                <Finance />
              </>
            }
          />
          <Route
            path="/utah-at-a-glance/utah-financial-institutions"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Financial Institutions | Banks, Credit Unions,
                    Investment
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Financial Institutions | Banks, Credit Unions, Investment"
                  />
                  <meta
                    name="description"
                    content="Discover top Utah financial institutions, banks, and credit unions with trusted services."
                  />
                  <meta
                    property="og:description"
                    content="Discover top Utah financial institutions, banks, and credit unions with trusted services."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/financial-institutions"
                  />
                </Helmet>
                <Finance />
              </>
            }
          />

          <Route
            path="/privacy-policy"
            element={
              <>
                <Helmet>
                  <title>Privacy Policy | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Privacy Policy | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Review how we collect, use, and protect your data when you visit UtahData.org services."
                  />
                  <meta
                    property="og:description"
                    content="Review how we collect, use, and protect your data when you visit UtahData.org services."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/privacy-policy"
                  />
                </Helmet>
                <PrivacyPolicy />
              </>
            }
          />

          <Route
            path="/kcg"
            element={
              <>
                <Helmet>
                  <title>KCG Chatbot | Ask Utah Questions | AI Helpdesk</title>
                  <meta
                    property="og:title"
                    content="KCG Chatbot | Ask Utah Questions | AI Helpdesk"
                  />
                  <meta
                    name="description"
                    content="Chat with KCG AI bot for real-time help on Utah data, services, and information resources."
                  />
                  <meta
                    property="og:description"
                    content="Chat with KCG AI bot for real-time help on Utah data, services, and information resources."
                  />
                  <link rel="canonical" href="https://www.utahdata.org/kcg" />
                </Helmet>
                <KCG />
              </>
            }
          />

          <Route
            path="/login"
            element={
              <>
                <Helmet>
                  <title>Login | UtahData.org Portal Access</title>
                  <meta
                    property="og:title"
                    content="Login | UtahData.org Portal Access"
                  />
                  <meta
                    name="description"
                    content="Secure login to access UtahData.org features, dashboards, insights, and admin tools easily."
                  />
                  <meta
                    property="og:description"
                    content="Secure login to access UtahData.org features, dashboards, insights, and admin tools easily."
                  />
                  <link rel="canonical" href="https://www.utahdata.org/login" />
                </Helmet>
                <Login />
              </>
            }
          />

          <Route
            path="/get-naics"
            element={
              <>
                <Helmet>
                  <title>
                    Get NAICS Codes | Utah Business Classification Search
                  </title>
                  <meta
                    property="og:title"
                    content="Get NAICS Codes | Utah Business Classification Search"
                  />
                  <meta
                    name="description"
                    content="Search and retrieve NAICS codes for Utah businesses by industry and classification type fast."
                  />
                  <meta
                    property="og:description"
                    content="Search and retrieve NAICS codes for Utah businesses by industry and classification type fast."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/get-naics"
                  />
                </Helmet>
                <Naics />
              </>
            }
          />
          <Route
            path="/get-naics-rules"
            element={
              <>
                <Helmet>
                  <title>
                    NAICS Compliance Rules | U.S. Food Industry Guide
                  </title>
                  <meta
                    property="og:title"
                    content="NAICS Compliance Rules | U.S. Food Industry Guide"
                  />
                  <meta
                    name="description"
                    content="Get U.S. food-industry compliance suggestions by NAICS code including agencies, regulations, permits, and required documentation."
                  />
                  <meta
                    property="og:description"
                    content="Get U.S.  food-industry compliance suggestions by NAICS code including agencies, regulations, permits, and required documentation."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/get-naics-rules"
                  />
                </Helmet>
                <NaicsRules />
              </>
            }
          />
          <Route
            path="/get-naics-rules-experimental"
            element={
              <>
                <Helmet>
                  <title>
                    NAICS Rules Explorer (Experimental) | U.S. Food Industry Guide
                  </title>
                  <meta
                    property="og:title"
                    content="NAICS Rules Explorer (Experimental) | U.S. Food Industry Guide"
                  />
                  <meta
                    name="description"
                    content="Experimental NAICS compliance view with clearer layout for regulations, permits, registrations, and required documents."
                  />
                  <meta
                    property="og:description"
                    content="Experimental NAICS compliance view with clearer layout for regulations, permits, registrations, and required documents."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/get-naics-rules-experimental"
                  />
                </Helmet>
                <NaicsRulesVariant />
              </>
            }
          />

          <Route
            path="/copyright"
            element={
              <>
                <Helmet>
                  <title>Copyright Notice | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Copyright Notice | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Read about copyright usage, rights reserved, and permitted use of UtahData.org's published data."
                  />
                  <meta
                    property="og:description"
                    content="Read about copyright usage, rights reserved, and permitted use of UtahData.org's published data."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/copyright"
                  />
                </Helmet>
                <CopyRight />
              </>
            }
          />

          <Route
            path="/wip"
            element={
              <>
                <Helmet>
                  <title>Coming Soon | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Coming Soon | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="This page is under development. UtahData.org is constantly evolving to serve you better."
                  />
                  <meta
                    property="og:description"
                    content="This page is under development. UtahData.org is constantly evolving to serve you better."
                  />
                  <link rel="canonical" href="https://www.utahdata.org/wip" />
                </Helmet>
                <WIP />
              </>
            }
          />

          <Route
            path="/sitemap1"
            element={
              <>
                <Helmet>
                  <title>Site Map | Explore UtahData.org Sections</title>
                  <meta
                    property="og:title"
                    content="Site Map | Explore UtahData.org Sections"
                  />
                  <meta
                    name="description"
                    content="Navigate all pages and features of UtahData.org using our interactive sitemap and menu tree."
                  />
                  <meta
                    property="og:description"
                    content="Navigate all pages and features of UtahData.org using our interactive sitemap and menu tree."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/sitemap1"
                  />
                </Helmet>
                <Honeycomb />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/research-centers-and-institutes"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Research Centers & Institutes | Innovation & Science
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Research Centers & Institutes | Innovation & Science"
                  />
                  <meta
                    name="description"
                    content="Explore Utah’s top research centers and innovation hubs driving science, tech, and progress."
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s top research centers and innovation hubs driving science, tech, and progress."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/research-centers-and-institutes"
                  />
                </Helmet>
                <ResearchCenters />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-research-centers-and-institutes"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Research Centers & Institutes | Innovation & Science
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Research Centers & Institutes | Innovation & Science"
                  />
                  <meta
                    name="description"
                    content="Explore Utah’s top research centers and innovation hubs driving science, tech, and progress."
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah’s top research centers and innovation hubs driving science, tech, and progress."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/research-centers-and-institutes"
                  />
                </Helmet>
                <ResearchCenters />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-mines"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Mines | Locations, Resources & Mining History
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Mines | Locations, Resources & Mining History"
                  />
                  <meta
                    name="description"
                    content="Explore Utah's mining history, resources, and active mine locations for minerals and extraction."
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah's mining history, resources, and active mine locations for minerals and extraction."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/utah-mines"
                  />
                </Helmet>
                <MinesPage />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-libraries"
            element={
              <>
                <Helmet>
                  <title>
                    Utah Public Libraries | Branches, Services, and Resources
                  </title>
                  <meta
                    property="og:title"
                    content="Utah Public Libraries | Branches, Services, and Resources"
                  />
                  <meta
                    name="description"
                    content="Search Utah’s public libraries for locations, hours, community programs, and educational tools."
                  />
                  <meta
                    property="og:description"
                    content="Search Utah’s public libraries for locations, hours, community programs, and educational tools."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/utah-libraries"
                  />
                </Helmet>
                <LibraryNew />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/draft"
            element={
              <>
                <Helmet>
                  <title>Utah At a Glance - Draft Page | UtahData.org</title>
                  <meta
                    property="og:title"
                    content="Utah At a Glance - Draft Page | UtahData.org"
                  />
                  <meta
                    name="description"
                    content="This draft page is in progress and will soon contain Utah summary data for easy navigation."
                  />
                  <meta
                    property="og:description"
                    content="This draft page is in progress and will soon contain Utah summary data for easy navigation."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org/utah-at-a-glance/draft"
                  />
                </Helmet>
                {/* <UtahAtAGlanceDraft /> */}
              </>
            }
          />

          <Route
            path="/faq"
            element={
              <>
                <Helmet>
                  <title>
                    FAQs | Frequently Asked Questions - UtahData.org
                  </title>
                  <meta
                    property="og:title"
                    content="FAQs | Frequently Asked Questions - UtahData.org"
                  />
                  <meta
                    name="description"
                    content="Get answers to common questions about UtahData.org, data sources, and available features."
                  />
                  <meta
                    property="og:description"
                    content="Get answers to common questions about UtahData.org, data sources, and available features."
                  />
                  <link rel="canonical" href="https://www.utahdata.org/faq" />
                </Helmet>
                <FAQ />
              </>
            }
          />

          <Route
            path="/utah-at-a-glance/utah-counties/utah-county"
            element={
              <>
                <Helmet>
                  <title>Utah County Data | Demographics, Jobs, Growth</title>
                  <meta
                    property="og:title"
                    content="Utah County Data | Demographics, Jobs, Growth"
                  />
                  <meta
                    name="description"
                    content="Explore Utah County's latest population stats, job trends, growth projections, and more."
                  />
                  <meta
                    property="og:description"
                    content="Explore Utah County's latest population stats, job trends, growth projections, and more."
                  />
                  <link
                    rel="canonical"
                    href="https://www.utahdata.org//utah-at-a-glance/utah-counties/utah-county"
                  />
                </Helmet>
                <UtahCounty />
              </>
            }
          />

          <Route path="/utah-at-a-glance/utah-budget" element={<UtahBudget />} />

          <Route path="/register" element={<Register />} />

          {/* <Route path="/kcg-sandbox22" element={<KCGSandbox />} />
           <Route path="/kcg-sandbox1" element={<KCGSandbox1 />} />
              <Route path="/kcg-sandbox2" element={<KCGSandbox2 />} /> */}
          <Route path="/kcg-sandbox" element={<KCGSandbox3 />} />
          <Route path="/kcg-sandbox11" element={<KCGSandbox11 />} />

          <Route path="/*" element={<Torch404 />} />

          {/* <Route
            path="/utah-at-a-glance"
            element={<UtahAtAGlance />}
          /> */}
        </Routes>
      </HelmetProvider>
    </>
  );
}

export default App;
